import { cn } from "~/lib/utils";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavGroup } from "./types";
import { areNavItemsActive } from "./isNavItemActive";
import { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { MobileNavItem } from "./MobileNavItem";

// // // //

export function MobileNavGroup(props: {
    activePathname: string;
    group: NavGroup;
    index: number;
}) {
    const { activePathname, group, index } = props;
    const { items, defaultExpandedState = true } = group;
    const expandable = true;

    const hasActiveChild = areNavItemsActive({
        items: group.items,
        pathname: activePathname,
    });
    const [expanded, setExpanded] = useState(
        hasActiveChild ? true : defaultExpandedState,
    );
    const hasLabel = group.label !== undefined;

    return (
        <FeatureFlag feature={group.featureFlag}>
            <div
                className={cn({
                    "pt-3": hasLabel,
                    "mt-2 border-t": index > 0,
                })}
            >
                {hasLabel && (
                    <>
                        {expandable ? (
                            <button
                                type="button"
                                aria-expanded={expanded}
                                className="mb-1 flex w-full items-center justify-between rounded-sm px-3 py-1 text-left text-muted-foreground hover:bg-muted transition-colors"
                                onClick={() => {
                                    setExpanded(!expanded);
                                }}
                            >
                                <p className="label-03 leading-normal">
                                    {group.label}
                                </p>
                                <FontAwesomeIcon
                                    icon={
                                        expanded ? faChevronDown : faChevronUp
                                    }
                                    className="h-[16px] w-[16px] text-sidebar-foreground"
                                />
                            </button>
                        ) : (
                            <div className="mb-1 flex items-center justify-between px-3">
                                <p className="label-03 leading-normal text-muted-foreground">
                                    {group.label}
                                </p>
                            </div>
                        )}
                    </>
                )}
                <div
                    className={cn("transition-all overflow-hidden", {
                        "h-0!": !expanded,
                        // "h-auto": expanded || collapsed,
                        "h-full": expanded,
                    })}
                >
                    {items.map((item) => (
                        <MobileNavItem
                            key={item.key}
                            item={item}
                            activePathname={activePathname}
                        />
                    ))}
                </div>
            </div>
        </FeatureFlag>
    );
}
